export default function getResource(label, vars = []) {
    const resources = {
        estimatedTotal: 'Estimated Total',
        googlePayErrorMessage:
            'Unable to place your order. Trouble connecting to Google Pay. Please use a different payment method or try again later.<br /><br />If applicable, we have reversed any pending charges to your account.',
        googlePayErrorOkButton: 'OK',
        googlePayErrorTitle: 'Error',
        googlePayGenericError: 'We experienced an error, please try again',
        googlePayRenderErrorMessage: 'Unable to select Google Pay. Please try again or select another payment method.',
        payWithGooglePay: 'Pay with Google Pay',
        shippingOptionPlaceholderDescription: 'Enter address to see options',
        shippingOptionPlaceholderLabel: 'Calculating…',
        total: 'Total'
    };

    return resources[label];
}
